import React from 'react';

import {
  ACHIEVEMENTS_REGISTRY,
  DailyRewardOpenResultDto,
  DailyRewardSlotDto,
  EDailyRewardType,
  formatMoney,
  TAchievementId,
} from '@skillarea/lib-shared';
import { useTranslation } from 'react-i18next';

import { getChestAchievementImage } from './chestAchievementImages';
import { Coin } from './Coin';
import styles from './Chests.module.scss';

interface IChestRewardContentProps {
  rewardType?: EDailyRewardType;
  rewardCoins?: number;
  rewardAchievementId?: TAchievementId;
}

export function resolveChestSlotReward(
  slot: DailyRewardSlotDto,
  openingReward: DailyRewardOpenResultDto | null,
): IChestRewardContentProps {
  const rewardOverride =
    openingReward?.dayIndex === slot.dayIndex ? openingReward : null;

  return {
    rewardType: rewardOverride?.rewardType ?? slot.rewardType,
    rewardCoins: rewardOverride?.coins ?? slot.coins,
    rewardAchievementId: rewardOverride?.achievementId ?? slot.achievementId,
  };
}

export const ChestRewardContent: React.FC<IChestRewardContentProps> = ({
  rewardAchievementId,
  rewardCoins,
  rewardType,
}) => {
  const { t } = useTranslation('dashboard');

  if (rewardType === EDailyRewardType.coins) {
    return (
      <Coin className={styles.rewardCoin} value={formatMoney(rewardCoins)} />
    );
  }

  if (rewardType === EDailyRewardType.empty) {
    return <div className={styles.rewardEmpty}>{t('chests.rewardEmpty')}</div>;
  }

  if (rewardType === EDailyRewardType.achievement) {
    const imageSrc = getChestAchievementImage(rewardAchievementId);
    const achievementName = rewardAchievementId
      ? ACHIEVEMENTS_REGISTRY[rewardAchievementId]?.name
      : undefined;

    return (
      <div className={styles.rewardAchievement}>
        {imageSrc ? (
          <img
            alt={achievementName ?? ''}
            className={styles.rewardAchievementImage}
            src={imageSrc}
          />
        ) : (
          <span className={styles.rewardAchievementFallback}>
            {achievementName ?? t('chests.rewardAchievementFallback')}
          </span>
        )}
      </div>
    );
  }

  return null;
};
